(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/statistics/statistics-constants/assets/javascripts/statistics-constants.js') >= 0) return;  svs.modules.push('/components/statistics/statistics-constants/assets/javascripts/statistics-constants.js'); (function(svs) {
  'use strict';


  svs.statistics = svs.statistics || {};
  svs.statistics.constants = svs.statistics.constants || {};

  svs.statistics.constants.SOCCER = 1000002;
  svs.statistics.constants.HOCKEY = 1000003;
  svs.statistics.constants.TENNIS = 1000007;
  svs.statistics.constants.TABLE_TENNIS = 1000022;
  svs.statistics.constants.BADMINTON = 1000043;
  svs.statistics.constants.AMERICAN_FOOTBALL = 1000046;
  svs.statistics.constants.BEACH_VOLLEYBALL = 1000023;
  svs.statistics.constants.VOLLEYBALL = 1000049;
  svs.statistics.constants.TROTTING = 1000060;
  svs.statistics.constants.SPECIAL_EVENT = 1000062;

  svs.statistics.constants.TYPE_TROTTING = 58;

  svs.statistics.constants.HARDCOURT = 'hardcourt';
  svs.statistics.constants.GRASS = 'grass';
  svs.statistics.constants.GRAVEL = 'gravel';
  svs.statistics.constants.GROUND_TYPE = 'underlag';

  svs.statistics.constants.DEFAULT_LEAGUES_LOAD_COUNT = 20;

  svs.statistics.constants.MATCH_STATUS_POSTPONED = 23;
  svs.statistics.constants.MATCH_STATUS_START_DELAYED = 24;
  svs.statistics.constants.MATCH_STATUS_CANCELLED = 25;
  svs.statistics.constants.MATCH_STATUS_INTERRUPTED = 26;

  svs.statistics.constants.SPECIAL_TROTTING_DRAW = 1736; 

  if (typeof exports === 'object') {
    module.exports = svs.statistics.constants;
  }
})(svs);

 })(window);